import { Link } from "gatsby"
import React from "react"

const SignUpBox = ({ body, message, type, cta }) => {
  return (
    <div className="box">
      <div className="has-text-centered">
        <p className="has-text-weight-bold is-size-5-mobile is-size-4-tablet is-size-3-widescreen">
          {body}
        </p>
        <Link 
            className="button is-link is-rounded is-medium"
            to={`/app/signup?type=${type}`}
            state={{
                signupPayload: {message},
            }}
        >
            {cta}
        </Link>
      </div>
    </div>
  )
}

export default SignUpBox
